import React, { Component } from "react";
import { NavItem, Nav, NavDropdown, MenuItem } from "react-bootstrap";
class HeaderLinks extends Component {
  constructor(props){
    super(props);
  }
  handleSignout =() =>{
    console.log("I want to log out ");
    localStorage.setItem("NAME","not found");
  }
  render() {
    // const notification = (
    //   <div>
    //     <i className="fa fa-globe" />
    //     <b className="caret" />
    //     <span className="notification">5</span>
    //     <p className="hidden-lg hidden-md">Notification</p>
    //   </div>
    // );
    return (
      <div>
        <Nav pullRight>
          
          <NavDropdown
            eventKey={1}
            title="Profile"
            id="basic-nav-dropdown-right"
          >
            <MenuItem eventKey={2.1} href="/#/create">Create User</MenuItem>
            <MenuItem eventKey={2.2} href="/#/change">Change Password</MenuItem>
            <MenuItem divider />
            <MenuItem eventKey={2.5} href="/#/login" onClick={this.handleSignout}>Log Out</MenuItem>
          </NavDropdown>
          
        </Nav>
      </div>
    );
  }
}

export default HeaderLinks;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx